import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables the Irrelevance Carousel Differentiation UX for retailers.
 */
export const IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425 =
  'IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425' as SettingConst<
    'IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425',
    boolean,
    'RETAILER'
  >;
